
import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TaskService } from '../../services/task/task.service';
import { Contact } from 'src/classes/contact';
import { Task,TaskObject } from 'src/classes/task';
import { Delivery } from 'src/classes/delivery';
import { Schedule } from 'src/classes/schedule';
import { ContactService } from 'src/services/contact/contact.service';

@Component({
  selector: 'app-edit-task-page',
  templateUrl: './edit-task-page.component.html',
  styleUrls: ['./edit-task-page.component.scss']
})
export class EditTaskPageComponent implements OnInit {
  public stage: number;
  public contacts: Contact[] = [];
  public isLoadingContacts = false;
  public isLoadingTask = false;
  public showBackButtonFirstStage = false;
  public availableTags: {tag: string, count: number}[] = [];
  @Input() task: Task = new Task();

  public error = {
    active: false,
    title: 'Unknown error',
    message: 'The error state was activated incorrectly',
    stack: 'No additional info available'
  };

  constructor(
    private taskService: TaskService,
    private contactService: ContactService,
    private route: ActivatedRoute
  ) {}

  async fetchContacts() {
    if (this.isLoadingContacts) {
      console.warn('Already loading contacts');
      return;
    }
    this.isLoadingContacts = true;
    const response: any = await this.contactService.listContacts();
    if (!response.data) {
      throw new Error('Unexpected server result');
    }
    const list = response.data;
    this.contacts = list.map(c => {
      if (typeof c.idContact !== 'number') {
        console.warn('Incorrect contact id format: ', typeof c.idContact);
        c.idContact = typeof c.idContact === 'string' ? parseInt(c.idContact, 10) : c.idContact;
      }
      return Object.assign(c, new Contact());
    });
    this.isLoadingContacts = false;
  }

  get isEditPage() {
    return this.route.snapshot.routeConfig.path.includes('edit');
  }

  get isViewPage() {
    return this.route.snapshot.routeConfig.path.includes('view');
  }

  displayErrorData(err) {
    console.error(err);
    this.error.title = 'Error loading contacts';
    this.error.message = err.message;
    this.error.stack = err.stack;
    this.error.active = true;
  }

  ngOnInit() {
    try {
      this.fetchTags();
      this.fetchContacts().catch(this.displayErrorData.bind(this));
      const id = this.route.snapshot.paramMap.get('id');
      if (id !== null && !isNaN(parseInt(id, 10))) {
        this.loadTask(parseInt(id, 10)).catch(this.displayErrorData.bind(this));
        if (this.isEditPage) {
          this.stage = 0;
          this.showBackButtonFirstStage = true;
        } else if (this.isViewPage) {
          this.stage = 4;
        } else {
          console.warn("Unknown page type, defaulting to edit");
          this.stage = 0;
        }
      } else {
        this.stage = 0;
      }
    } catch(err) {
      this.displayErrorData(err);
    }
  }

  async fetchTags() {
    this.availableTags = await this.contactService.getTags();
  }

  async loadTask(id: number) {
    try {
      this.isLoadingTask = true;
      console.log(`Task ${id} Loaded`);
      this.task = await this.taskService.getTask(id);
      this.task.id = id;
    } catch(err) {
      this.displayErrorData(err);
    }
    this.isLoadingTask = false;
  }

  onChangeState(value: number) {
    if (value >= 0 && value <= 4) {
      this.stage = value;
    }
  }

  addDelivery(delivery: Delivery) {
    this.task.deliveryContacts.push(delivery);
  }

  updateDelivery(delivery: Delivery) {
    if (!delivery.idDelivery) {
      throw new Error('Cannot update delivery without id');
    }
    for (const subDelivery of this.task.deliveryContacts) {
      if (subDelivery.idDelivery !== delivery.idDelivery) {
        continue;
      }
      subDelivery.subject = delivery.subject;
      subDelivery.message = delivery.message;
      subDelivery.type = delivery.type;
      subDelivery.tags = delivery.tags;
      subDelivery.contactId = delivery.contactId;
    }
  }

  deleteDelivery(id: number) {
    let index: number;
    for (let i = this.task.deliveryContacts.length - 1; i >= 0; i--) {
      const element = this.task.deliveryContacts[i];
      if (element.idDelivery === id) {
        index = i;
        break;
      }
    }
    if (index !== undefined && index !== null && index >= 0 && index < this.task.deliveryContacts.length) {
      this.task.deliveryContacts.splice(index, 1);
    }
  }

  addPage(obj: TaskObject) {
    if(this.task.objects.length==0){
      obj.reportOrder=1;
    }
    else{
      obj.reportOrder = this.task.objects.map(i=>i.reportOrder).sort((a,b)=>b-a).shift()+1;
    }
    this.task.objects.push(obj);
  }

  updatePage(obj: TaskObject) {
    if (!obj.reportOrder) {
      throw new Error('Cannot update page without id');
    }
    for (const obj1 of this.task.objects) {
      if (!(obj1.reportOrder == obj.reportOrder  && obj1.type == obj.type) ){
        continue;
      }
      obj1.name = obj.name;
      obj1.objectId = obj.objectId;
      obj1.type = obj.type;
      obj1.pageView = obj.pageView;
      obj1.page = obj.page;
      obj1.width = obj.width;
      obj1.height = obj.height;
    }
  }

  deletePage(id: TaskObject) {
    console.log(id)
    let index: number;
    console.log(this.task.objects);
    for (let i = this.task.objects.length - 1; i >= 0; i--) {
      const element = this.task.objects[i];
      if (element.reportOrder === id.reportOrder && element.type === id.type) {
        index = i;
        break;
      }
    }
    console.log(index)
    if (index !== undefined && index !== null && index >= 0 && index <= this.task.objects.length) {
      this.task.objects.splice(index, 1);
    }
  }

  addSchedule(schedule: Schedule) {
    this.task.schedules.push(schedule);

  }

  updateSchedule(schedule: Schedule) {
    if (!schedule.idSchedules) {
      throw new Error('Cannot update schedule without id');
    }
    for (const subSchedule of this.task.schedules) {
      if (subSchedule.idSchedules !== schedule.idSchedules) {
        continue;
      }
      subSchedule.rule = schedule.rule;
      subSchedule.status = schedule.status;
      subSchedule.type = schedule.type;
    }
  }

  deleteSchedule(id: number) {
    let index: number;
    for (let i = this.task.schedules.length - 1; i >= 0; i--) {
      const element = this.task.schedules[i];
      if (element.idSchedules === id) {
        index = i;
        break;
      }
    }
    if (index !== undefined && index !== null && index >= 0 && index < this.task.schedules.length) {
      this.task.schedules.splice(index, 1);
    }
  }

}
